import React from 'react';
import { SecureRoute, Security, LoginCallback } from '@okta/okta-react';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { BrowserRouter as Router, Route, useHistory, Redirect, Switch } from 'react-router-dom';
import Home from "./components/Home";
import ReceiveData from "./components/ReceiveData";
import Logout from "./components/Logout"

const oktaAuth = new OktaAuth({
    issuer: process.env.REACT_APP_ISSUER,
    clientId: process.env.REACT_APP_CLIENT_ID,
    redirectUri: window.location.origin + '/login/callback'
});

const App = () => {
    const history = useHistory();
    const restoreOriginalUri = async (_oktaAuth, originalUri) => {
        history.replace(toRelativeUrl(originalUri || '/', window.location.origin));
    };

    return (
        <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
            <Switch>
                <Route path='/' exact={true} component={Home} />
                <Route path="/retrieve/:id/:secret" component={ReceiveData} />
                <Route path='/login/callback' component={LoginCallback} />
                <Route path='/logout' component={Logout}/>
                {/*<Route path='/retrieve' exact={true} component={Home} />*/}
            </Switch>
        </Security>
    );
};

const AppWithRouterAccess = () => (
    <Router>
        <App />
    </Router>
);

export default AppWithRouterAccess;